import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { CREATE_INTEGRATION_DATA, CREATE_INTEGRATION_DATA_SUCCESS, CREATE_INTEGRATION_DATA_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* createIntegrationData({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/data-integration`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: CREATE_INTEGRATION_DATA_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CREATE_INTEGRATION_DATA_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_INTEGRATION_DATA_ERROR, payload: error });
  }
}

export function* watchCreateIntegrationData() {
  yield takeEvery(CREATE_INTEGRATION_DATA, createIntegrationData);
}

function* createIntegrationDataSaga() {
  yield all([fork(watchCreateIntegrationData)]);
}

export default createIntegrationDataSaga;
